import React from 'react'
import { useMediaQuery } from '@mantine/hooks'
import { Box, Radio } from '@node-space/ui-components'
import { useProtocolContext } from 'hooks/context'

export const ProtocolsRadioButtons = () => {
  const { protocols, currentProtocol, setProtocol } = useProtocolContext()
  const isMobileScreen = useMediaQuery('(min-width: 640px)')

  const getRadioOptions = () => {
    return protocols.map(protocol => {
      return {
        label: protocol?.code,
        value: protocol?.address,
      }
    })
  }
  const handleChange = (value: string, label: string) => {
    setProtocol({
      code: label,
      address: value,
    })
  }
  if (!protocols.length) {
    return <></>
  }
  return (
    <Box width="full" paddingB={28} data-testid="protocol-radio-button-group">
      <Radio
        testId="protocol"
        horizontal={isMobileScreen}
        onChange={handleChange}
        options={getRadioOptions()}
        value={currentProtocol.address}
        border={true}
      />
    </Box>
  )
}
